export const appendSearchParam = (key: string, value: string) => {
    const sp = new URLSearchParams(window.location.search.slice(1));
    sp.set(key, value);
    // pathname может прийти с задвоенными слэшами (https://host//?...) — не размножаем их
    const newUrl = `${window.location.pathname.replace(/\/{2,}/g, '/')}?${sp.toString()}`;

    // Update URL without reload
    window.history.pushState(null, '', newUrl);
};

export const deleteSearchParam = (key: string) => {
    const sp = new URLSearchParams(window.location.search.slice(1));
    sp.delete(key);
    const newUrl = `${window.location.pathname.replace(/\/{2,}/g, '/')}?${sp.toString()}`;

    // Update URL without reload
    window.history.pushState(null, '', newUrl);
};

export const appendSearchParams = (url: string, search: string): string => {
    if (!search) return url;
    // window.location.search начинается с "?"
    // Если URL уже содержит "?", заменяем "?" в search на "&"
    if (url.includes('?')) {
        return url + search.replace('?', '&');
    }
    return url + search;
};
